/// <reference path="../../../app.definition.ts" />

import angular from "angular";
import * as _ from "lodash";
import { FieldTypeEnum } from "@common/model/analytics.model";
import { Util } from "@common/util";

interface IEcvField {
    init();
}

class EcvField implements IEcvField {
    resetOnLoad: Function;
    invalidDateMsg;
    static $inject = ["$scope", "$interpolate", "FieldService", "$timeout"];
    constructor(
        $scope,
        $interpolate,
        FieldService,
        $timeout
    ) {
        this.invalidDateMsg = Util.INVALID_DATE;
        $scope.filedTypes = FieldTypeEnum;
        const selectTxt = 'SELECT ALL';
        const deSelectTxt = 'DESELECT ALL';
        let disableCondition = "false";
        const attribs = $scope.field.attributes;
        if (Array.isArray(attribs) && attribs.length > 0) {
            const attribDisable = attribs.find(a => a.name == 'ng-disabled');
            if (attribDisable) {
                disableCondition = attribDisable.value;
            }
        }


        $scope.events = $scope.field.events;

        $scope.isDisabled = () => {
            !!$scope.field.formUtil && (FieldService.ctrl = $scope.field.formUtil);
            const flag = $interpolate(disableCondition)(FieldService);
            return (flag == "true");
        }

        $scope.groupFind = function (item) {
            if ($scope.field.groupBy) {
                return item[$scope.field.groupBy];
            }
            return selectTxt;
        }

        //On open/close of multi-select dropdown
        $scope.onOpenClose = function (isOpen, $select, key) {
            if (!!isOpen) {
                $timeout(() => {
                    let drpdwnHeader = $('#ui-select-choices-' + $select.generatedId).find('.dropdown-header');

                    //If all the values are already selected then on open show deselect all option
                    if (!!$scope.field.value && $select.items.length == $scope.field.value.length) {
                        drpdwnHeader.text(deSelectTxt);
                    } else {
                        drpdwnHeader.text(selectTxt);
                    }

                    //Click handler for select/deselect option
                    drpdwnHeader.off('click').on('click', () => {
                        let selectAll = true;
                        if (!$scope.field.value)
                            $scope.field.value = [];

                        //For lea,campus dropdowns the options have ids array, for other dropdowns the options have id. 
                        //So passing the indexKey from the config for each field. If indexKey not found then use the default key
                        let fldInd = ($scope.field.additionalProps && $scope.field.additionalProps.indexKey) ? $scope.field.additionalProps.indexKey : key;
                        let deselected = $select.items.find(opt => $scope.field.value.findIndex(v => _.isEqual(v[fldInd], opt[fldInd])) == -1);
                        if (!deselected) {
                            selectAll = false;
                        }
                        let chngTxt = !!selectAll ? deSelectTxt : selectTxt;
                        drpdwnHeader.text(chngTxt);
                        if (!!selectAll) {
                            for (let opt of $select.items) {
                                if ($scope.field.value.findIndex(v => _.isEqual(v[fldInd], opt[fldInd])) == -1)
                                    $scope.field.value.push(opt);
                            }
                        } else {
                            for (let opt of $select.items) {
                                $scope.field.value = $scope.field.value.filter(v => !_.isEqual(v[fldInd], opt[fldInd]));
                            }
                        }
                        $scope.valueChanged();
                    });
                }, 10);
            } else {
                $select.search = "";
                $scope.handleBlur();
            }
        }

        $scope.valueChanged = (selectFld) => {
            let changeEvent;
            //If valueChanged of multi-select field is called then check total items
            // selected and accordingly show select/deselect all option
            if (!!selectFld && selectFld.items.length == $scope.field.value.length) {
                let drpdwnHeader = $('#ui-select-choices-' + selectFld.generatedId).find('.dropdown-header');
                drpdwnHeader.text(deSelectTxt);
            }
            ///////////

            $scope.events && (changeEvent = _.cloneDeep($scope.events["ng-change"]));
            $timeout(() => {
                if (!!changeEvent && !!$scope.onFieldEvent) {
                    //On teamcard we have cstm attr and view history which both use FieldService, hence when called from cstm attr we need to set ctrl to formsUtility
                    !!$scope.field.formUtil && (FieldService.ctrl = $scope.field.formUtil);
                    FieldService.onFieldEvent(changeEvent);
                } else {
                    return false;
                }
            }, 10);
        }
        $scope.handleBlur = () => {
            let event;
            !!$scope.events && (event = _.cloneDeep($scope.events["ng-blur"]));
            if (!!event && !!$scope.onFieldEvent) {
                !!$scope.field.formUtil && (FieldService.ctrl = $scope.field.formUtil);
                FieldService.onFieldEvent(event);
            } else {
                return new Promise(resolve => resolve(false));
            }
        }

        $scope.handleClick = () => {
            let event;
            !!$scope.events && (event = $scope.events["ng-click"] || $scope.events["ecv-click"]);
            if (!!event && !!$scope.onFieldEvent) {
                return FieldService.onFieldEvent(event);
            } else {
                return new Promise(resolve => resolve(false));
            }
        }

        $scope.deselectItem = (event, key, opt) => {
            if (!!event) {
                event.preventDefault();
                event.stopPropagation();
            }
            //For lea,campus dropdowns the options have ids array, for other dropdowns the options have id. 
            //So passing the indexKey from the config for each field. If indexKey not found then use the default key
            let fldInd = ($scope.field.additionalProps && $scope.field.additionalProps.indexKey) ? $scope.field.additionalProps.indexKey : key;
            $scope.field.value = $scope.field.value.filter(i => !_.isEqual(i[fldInd], opt[fldInd]));
            $(event.currentTarget).parents('.ui-select-choices-row').siblings('.dropdown-header').text(selectTxt);
            $scope.valueChanged();
        }

        $scope.getItems = (items) => {
            if (Array.isArray(items) && !!$scope.field.additionalProps && !!$scope.field.additionalProps.showSelectedItemsLimit) {
                const arr = items.slice(0, $scope.field.additionalProps.showSelectedItemsLimit);
                let str = [];
                for (let i = $scope.field.additionalProps.showSelectedItemsLimit; i < items.length; i++) {
                    str.push(items[i].label);
                }
                $scope.tooltip = str.join(", ");
                $scope.extraItems = (items.length - arr.length);
                return arr;
            } else {
                $scope.extraItems = 0;
                return items;
            }
        }

        $scope.deselectPerson = (deselectedRecipient, $event) => {
            let subId;
            $event.preventDefault();
            $event.stopPropagation();
            if (!!deselectedRecipient.person) {
                subId = deselectedRecipient.person.subjectId;
                deselectedRecipient.person.selected = false;
            } else {
                subId = deselectedRecipient.subjectId;
                deselectedRecipient.selected = false;
            }

            $scope.field.value = $scope.field.value.filter((recipient) => {
                return recipient.subjectId != subId;
            });
            $scope.valueChanged();
        }
        $scope.deselectUser = (obj, $event) => {
            $event.preventDefault();
            $event.stopPropagation();
            $scope.field.value = $scope.field.value.filter((u) => {
                return u.userId != obj.person.userId;
            });
            $($event.currentTarget).parents('.ui-select-choices-row').siblings('.dropdown-header').text(selectTxt);
            $scope.valueChanged();
        }
        $scope.clear = ($event, $select) => {
            $event.preventDefault();
            $event.stopPropagation();
            $select.selected = undefined;
            $select.search = undefined;
        }
    }

    init = () => {

    }

}
interface IEcvFieldScope extends ng.IScope {
    element: ng.IAugmentedJQuery | null;
    resetOnLoad?: () => void; // Optional function
}

function ecvField(): ng.IDirective {
    return {
        restrict: 'E',
        templateUrl: 'app/common/directive/field/templates/field.directive.html',
        replace: true,
        controller: EcvField,
        controllerAs: 'fldVm',
        scope: {
            'field': '=config',
            'onFieldEvent': '&',
            'resetOnLoad': '=',
            'paramsFrm': '=?'
        },
        link: (scope: IEcvFieldScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: IEcvField): void => {
            scope.$on("$destroy", function () {
                scope.element = null;
            });
            scope.element = element;
            !!scope.resetOnLoad && (scope.resetOnLoad());
        }
    }
}

angular.module('eCareVault.common.directives').directive('ecvField', ecvField);
